import { apiGatewayClient } from '@/common/apis/client';
import axios from 'axios';
import { installSecretaryRouting } from '../secretary/routing';

/** apigw.paziresh24.com — the same gateway the providers (nelson) panel talks to. */
export const panelGateway = apiGatewayClient;

/** api.paziresh24.com/V1 — legacy doctor API used by the providers panel. */
export const panelLegacyV1 = axios.create({
  baseURL: 'https://api.paziresh24.com/V1',
  withCredentials: true,
});

/** drprofile.paziresh24.com — doctor profile service used by the providers panel. */
export const panelDrProfile = axios.create({
  baseURL: 'https://drprofile.paziresh24.com',
  withCredentials: true,
});

// the shared gateway client is routed in common/apis/client.ts; these two are the panel's own
installSecretaryRouting(panelLegacyV1, panelDrProfile);
